import { render, staticRenderFns } from "./MarketNewsCreate.vue?vue&type=template&id=27d93af7"
import script from "./MarketNewsCreate.vue?vue&type=script&lang=js"
export * from "./MarketNewsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports